import { useEffect, useRef } from 'react';

declare const bootstrap: any;

function Tooltip({ children, title, className = '', style, placement = 'top', html = false }: any) {
  const domRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<any>(null);

  useEffect(() => {
    if (domRef.current && title) {
      if (tooltipRef.current) {
        tooltipRef.current.dispose();
        tooltipRef.current = null;
      }

      domRef.current.setAttribute('title', title);
      domRef.current.setAttribute('data-bs-original-title', title);
      domRef.current.setAttribute('data-bs-placement', placement);
      if (html) domRef.current.setAttribute('data-bs-html', 'true');

      tooltipRef.current = new bootstrap.Tooltip(domRef.current, { placement, html });

      return () => {
        if (tooltipRef.current) {
          tooltipRef.current.dispose();
          tooltipRef.current = null;
        }
      };
    }
  }, [title, placement]);

  useEffect(() => {
    return () => {
      if (tooltipRef.current) {
        tooltipRef.current.dispose();
      }
    };
  }, []);

  return (
    <div
      {...(title ? { 'data-bs-toggle': 'tooltip', title } : {})}
      ref={domRef}
      className={className}
      style={style}
      role="tooltip"
    >
      {children}
    </div>
  );
}

export default Tooltip;
